import { Directive, HostListener, OnInit, ElementRef, Input } from '@angular/core';
import { isNullOrUndefined } from 'util';
import * as $ from 'jquery';

@Directive({
  selector: '[tableHeaderFixer]'
})

export class tableHeaderFixerDirective implements OnInit {
  constructor() { }

  @Input('tableHeaderFixer') options: any;

  ngOnInit() {  }

  ngAfterViewInit() { }

  fixHeader(){
    if(isNullOrUndefined(this.options)) {
      return
    }

    
    let { headerFix, colFix, noOfCol } = this.options.apply;
    let tableID = this.options.tableID;
    
    if(headerFix){
      $("#" + tableID + ' .fixed tr').each(function(){
        $(this).find('th').css({"position": "sticky", "top": $(this).position().top, "outline": "1px solid #e3e6f0"})
      });
    }

    /**
     * header colfix
     */
    if(colFix){
      let left = $("#" + tableID + " .fixed").position().left;
      let offset = $("#" + tableID + " .fixed th:nth-child(1)").position().left - left + 1;
      $("#" + tableID + " .fixed tr:nth-child(1) th:nth-child(-n+" + noOfCol + ")").each(function(){
        $(this).css({"position": "sticky", "zIndex": "3", "left": $(this).position().left - offset, "outline": "1px solid #e3e6f0"})
      });
    }
  }

  process() {
    if(isNullOrUndefined(this.options)) {
      return
    }
    
    let { colFix, rowFix, noOfCol, noOfRow } = this.options.apply;
    let tableID = this.options.tableID;

    /**
     * if rows are fixed at top
     */
    if(rowFix){
      let left = $("#" + tableID + " .bodyItems").position().left;
      let offset = $("#" + tableID + " .bodyItems td:nth-child(1)").position().left - left + 1;
      $("#" + tableID + " .bodyItems tr:nth-child(-n + " + noOfRow + ")").each(function(){
        if(colFix){
          let span = $(this).find("td:nth-child(1)").prop("colSpan");
          span = isNaN(span)?0:span;
          /**
           * Fix cols
           */
          $(this).find("td:nth-child(-n+" + (noOfCol - span + 1) + ")").each(function(){
            $(this).css({"position": "sticky", "zIndex": "3", "left": $(this).position().left - offset, "outline": "1px solid #e3e6f0"})
          });
        }
        /**
         * Fix row and it's cols
         */
        $(this).find('td').removeClass().addClass('fixed-row').css({"position": "sticky", "top": $(this).position().top, "outline": "1px solid #e3e6f0"})

      });
    }

    if(colFix){
      /**
       * Remaining rows
       */
      $("#" + tableID + " .bodyItems tr:nth-child(n+" + (((rowFix)?noOfRow:0)+1) + ")").each(function(){
        let left = $(this).position().left;
        let offset = (($(this).find("td:nth-child(1)").position())?$(this).find("td:nth-child(1)").position().left:0) - left + 1;

        let span = $(this).find("td:nth-child(1)").prop("colSpan");
        span = isNaN(span)?0:span;

        $(this).find("td:nth-child(-n+" + (noOfCol - span + 1) + ")").each(function(){
          $(this).addClass('fixed-col').css({"position": "sticky", "left": $(this).position().left - offset, "outline": "1px solid #e3e6f0"})
        })
      });
    }
  }
}
